/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar7 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar7", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.105,4,24,4z M17.586,15.879 l-2.842,5.664h-1.875l2.924-5.571v-0.098h-3.412v-1.382h5.205V15.879z M24,10H6V6h18V10z" />
      </svg>
    );
  }
}

IconCalendar7.defaultProps = {
  className: null
};

IconCalendar7.propTypes = {
  className: PropTypes.string
};

export default IconCalendar7;
